import React from 'react';
import { cn } from '../../lib/utils';

interface PageHeaderProps {
  eyebrow?: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ eyebrow, title, description, actions, className }) => (
  <div className={cn('mb-6 flex flex-wrap items-end justify-between gap-4 sm:mb-8', className)}>
    <div className="min-w-0">
      {eyebrow && (
        <p className="mb-1.5 text-xs font-medium tracking-wide text-brand uppercase">{eyebrow}</p>
      )}
      <h1 className="text-2xl font-semibold tracking-tight text-fg sm:text-[28px]">{title}</h1>
      {description && <p className="mt-1 hidden max-w-2xl text-sm text-fg-muted sm:block">{description}</p>}
    </div>
    {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
  </div>
);
